export const ICON_DOWNLOAD_SIZE = "iconDownload.size";

export const resetLocalStorage = () => {
    localStorage.removeItem(ICON_DOWNLOAD_SIZE);
};
